import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { changeActivePage } from 'actions/ListActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import Pagination from 'components/layout/Pagination';

import List from 'components/List';

import OrderInfosCustomer from 'components/layout/order/OrderInfosCustomer';

class OrderListCustomer extends React.Component {
  handlePagination = page => {
    // when the page changes, we need to dispatch event to fetch list
    const { list, changeActivePage } = this.props;
    changeActivePage('orders', page, list.resPerPage);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      types,
    } = this.props;

    const urlData = { filters: {} };
    if (types) {
      urlData.filters.type = types;
    }

    let currentBreadcrumbName = messages.orders;
    if (types.indexOf('car_service') > -1) {
      currentBreadcrumbName = messages.car_service_appointments;
    }

    return (
      <div class="padding-25 sm-padding-10">
        <List listName="orders" url="/api/orders.json" urlData={urlData} list={list} noRender />

        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: null, name: currentBreadcrumbName },
          ]}
        />

        {list.pending ? (
          <Loader />
        ) : (
          <div>
            {list.data.list.map(order => {
              return <OrderInfosCustomer order={order} key={order.id} />;
            })}

            <div class="text-center">
              <Pagination
                count={list.data.count}
                resPerPage={list.resPerPage}
                activePage={list.activePage}
                handleSelect={this.handlePagination}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
OrderListCustomer.defaultProps = {
  types: [],
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.orders,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeActivePage: (listName, activePage, resPerPage) => {
      dispatch(changeActivePage(listName, activePage, resPerPage));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(OrderListCustomer)
  )
);
